import { MapPin, Clock, Percent } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionTag } from "./SectionTag";

function GeofenceVisual() {
  return (
    <div className="relative flex h-56 items-center justify-center overflow-hidden rounded-2xl bg-ink">
      <div className="absolute h-44 w-44 rounded-full border border-white/10" />
      <div className="absolute h-28 w-28 rounded-full border border-white/15" />
      <div className="absolute h-14 w-14 rounded-full bg-gradient-brand" />
      <MapPin className="absolute text-white" size={22} />
      <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2.5 rounded-xl bg-white/95 p-3 shadow-xl">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-brand text-white">
          <MapPin size={15} />
        </div>
        <p className="text-xs font-semibold text-ink">Vous êtes près de la boutique !</p>
      </div>
    </div>
  );
}

function RelanceVisual() {
  return (
    <div className="flex h-56 flex-col justify-center gap-4 rounded-2xl bg-ink p-6">
      <div className="flex items-center gap-3 rounded-xl bg-white/5 p-3 text-white/70">
        <Clock size={16} className="shrink-0" />
        <p className="text-xs">Client inactif depuis 21 jours</p>
      </div>
      <div className="flex justify-center text-white/30">↓ relance automatique</div>
      <div className="flex items-center gap-2.5 rounded-xl bg-white/95 p-3.5 shadow-xl">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-brand text-white">
          <Clock size={15} />
        </div>
        <p className="text-xs font-semibold text-ink">Vous nous manquez — revenez cette semaine !</p>
      </div>
    </div>
  );
}

function LoyaltyTypeVisual() {
  const previews = [
    { label: "TAMPONS", value: "4/8" },
    { label: "CASHBACK", value: "12,50 €" },
    { label: "POINTS", value: "340" },
  ];
  return (
    <div className="flex h-56 items-center justify-center gap-3 rounded-2xl bg-ink p-6">
      {previews.map((p) => (
        <div key={p.label} className="flex flex-1 flex-col items-center gap-1 rounded-xl bg-white/95 px-3 py-5 text-center shadow-xl">
          <p className="text-[10px] font-bold tracking-wide text-ink-soft">{p.label}</p>
          <p className="text-lg font-extrabold text-ink">{p.value}</p>
        </div>
      ))}
    </div>
  );
}

const rows = [
  {
    icon: MapPin,
    accent: "bg-coral/10 text-coral",
    tag: "Géolocalisation",
    title: "La carte se rappelle à eux, sans rien envoyer.",
    description:
      "Quand un client passe à proximité, la carte remonte toute seule sur son écran verrouillé — un déclencheur natif du wallet, aucun coût, aucun geste de votre part.",
    visual: <GeofenceVisual />,
  },
  {
    icon: Clock,
    accent: "bg-coral/10 text-coral",
    tag: "Relance",
    title: "Récupérez les clients qui décrochent.",
    description:
      "Dès qu'un client n'est pas repassé depuis un moment, un message de relance part automatiquement pour le faire revenir avant qu'il ne vous oublie tout à fait.",
    visual: <RelanceVisual />,
  },
  {
    icon: Percent,
    accent: "bg-mint/10 text-mint-text",
    tag: "Format",
    title: "Tampons, cashback ou points — vous choisissez.",
    description:
      "Adaptez le programme à votre activité : tampons pour un passage régulier, cashback pour un panier moyen élevé, ou points pour plus de flexibilité.",
    visual: <LoyaltyTypeVisual />,
  },
];

export function LoyaltyFeatures() {
  return (
    <section className="bg-cream py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <SectionTag>Fidélisation</SectionTag>
          <h2 className="mt-5 text-4xl font-extrabold tracking-tight text-ink lg:text-5xl">
            Faites revenir vos clients,
            <br />
            <span className="text-gradient">sans y penser tous les jours.</span>
          </h2>
          <p className="mt-4 text-lg text-ink-soft">
            Chaque mécanisme tourne tout seul une fois configuré — zéro relance manuelle à
            faire au quotidien.
          </p>
        </Reveal>

        <div className="mt-16 flex flex-col gap-16">
          {rows.map((row, i) => (
            <div key={row.tag} className="grid items-center gap-10 lg:grid-cols-2">
              <Reveal delay={0.1} className={i % 2 === 1 ? "lg:order-2" : ""}>
                <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-bold uppercase tracking-wide ${row.accent}`}>
                  <row.icon size={14} />
                  {row.tag}
                </span>
                <h3 className="mt-4 text-2xl font-extrabold tracking-tight text-ink">{row.title}</h3>
                <p className="mt-3 text-ink-soft">{row.description}</p>
              </Reveal>

              <Reveal delay={0.15} className={i % 2 === 1 ? "lg:order-1" : ""}>
                {row.visual}
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
